import { CHALKIT_PRODUCTS, CHALKIT_URL, CHALKIT_MEMBER_URL } from "../data/mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function initChalkitTracking() {
  const handler = (e) => {
    const a = e.target.closest ? e.target.closest('a[href*="chalkitpro.com"]') : null;
    if (!a) return;
    const href = a.getAttribute("href");
    const product =
      Object.keys(CHALKIT_PRODUCTS).find((k) => CHALKIT_PRODUCTS[k] === href) ||
      (href === CHALKIT_URL ? "general_booking" : href === CHALKIT_MEMBER_URL ? "member_reserve" : "unknown");
    if (typeof window.gtag === "function") {
      window.gtag("event", "chalkit_click", {
        product,
        link_url: href,
        page_path: window.location.pathname,
      });
    }
    try {
      const body = JSON.stringify({ product, page_path: window.location.pathname });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/chalkit-clicks`, new Blob([body], { type: "application/json" }));
      } else {
        fetch(`${API}/chalkit-clicks`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
      }
    } catch (err) {}
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}

// GA4 events for phone / text / email taps site-wide (delegated; skips the admin dashboard)
export function initContactClickTracking() {
  const handler = (e) => {
    const a = e.target.closest ? e.target.closest("a[href^='tel:'], a[href^='sms:'], a[href^='mailto:']") : null;
    if (!a || window.location.pathname.startsWith("/admin")) return;
    const href = a.getAttribute("href");
    const eventName = href.startsWith("tel:") ? "phone_click" : href.startsWith("sms:") ? "text_click" : "email_click";
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, {
        link_url: href,
        page_path: window.location.pathname,
      });
    }
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}

// GA4 conversion event for the Chalk It Pro Goal Review booking button (fire-and-forget, never delays navigation)
export function trackGoalReviewBooking(buttonLocation, destinationUrl) {
  if (typeof window.gtag === "function") {
    window.gtag("event", "goal_review_booking_click", {
      booking_provider: "chalk_it_pro",
      booking_type: "goal_review",
      page_path: window.location.pathname,
      button_location: buttonLocation,
      destination_url: destinationUrl,
    });
  }
}
